import A6StaticData from "@/pages/a6/A6StaticData/main";
import A6TimeSeries from "@/pages/a6/A6TimeSeries/main";
import A6Transactions from "@/pages/a6/A6Transactions/main";
import A6Events from "@/pages/a6/A6Events/main";
import { Route, Routes } from "react-router-dom";
import A6DownloadCenter from "./A6DownloadCenter/main";
import A6Issuers from "./A6Issuers/main";
import A6PdfPageSelection from "./A6PdfPageSelection/main";
import A6Portfolios from "./A6Portfolios/main";
import A6DataUpload from "./A6DataUpload/main";
import A6BankPositions from "./A6BankPositions/main";

export default function A6Routes() {
  return (
    <Routes>
      <Route path="a6_events/*" element={<A6Events />} />
      <Route path="a6_static_data/*" element={<A6StaticData />} />
      <Route path="a6_time_series/*" element={<A6TimeSeries />} />
      <Route path="a6_transactions/*" element={<A6Transactions />} />
      <Route path="a6_bank_positions/*" element={<A6BankPositions />} />
      <Route path="a6_portfolios/*" element={<A6Portfolios />} />
      <Route path="a6_issuers/*" element={<A6Issuers />} />
      <Route path="a6_pdf_page_selection/*" element={<A6PdfPageSelection />} />
      <Route path="a6_download_center/*" element={<A6DownloadCenter />} />
      <Route path="a6_data_upload/*" element={<A6DataUpload />} />
    </Routes>
  );
}
